module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAFLSURBVEiJxdY/SwMxHMbx7+8SFH0FDg6Ogi614O4oVVxE6Lvoqigc4i6+j3MQ/yA4uDgItrh28AW4CgdFejYO9Uq5tja53qXPGJJ8SAg8gTmk9XB2KXNBDQ2vcIoCeIOHUW9wFvUCj0NLhyehpcL/oaXB09BSYBu0cNgWLRR2QQuDXdFC4DwoQOAJbQM3hcAuaILa+VpWh8B1Opjrql3R7Vr4CfB2d7KpRL0DWvtCm7fH6yLqCdDgeOKZ0EA/C6ykE6zhIlGwfFwZNDHIFZDkRa3gLErP1Ku18wY9U8/g1uhUePS7YtqLHf0IsLV/EQ3hTmh/L0t0sEDkZSEOdjeOwhigdX+694NuuqAT4aklnsHT2KJjYes+zeAu6AjsXG1/eGfpe9UFRYgHcN6WAXk1mDVrtA9HMhuaI0JsuqoSeEOFGCEyXVWpHoQfvwwP7sH9pYKRAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/padImg/dui.png
// module id = SLub
// module chunks = 1